import React from 'react';
import { Reveal } from './Reveal';
const audiences = ['Step Aerobics Instructors', 'Group Fitness Instructors', 'Personal Trainers', 'Cardio Dance Instructors', 'Fitness Studio Owners', 'Online Step Coaches'];
export function ProfessionalAudience() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-188" data-mp="3tf3j538dxx9r">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-189" data-mp="23ajm3320sl9">
        <h2 className="font-display text-4xl font-extrabold leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-190" data-mp="71vj20ahf88n">
          👟 Designed for <span className="text-green-dark" data-id="element-191" data-mp="bznbcvf1gwdd">Professional Instructors</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-192" data-mp="g21tfdavvs3l">
          If you teach step aerobics, group fitness, or cardio classes — this system was built for you.
        </p>
        <ul className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-193" data-mp="2huq0xyuk91p6">
          {audiences.map(audience => <li key={audience} className="rounded-full border border-sky-line bg-sky px-4 py-2.5 text-sm font-semibold text-ink shadow-premium" data-id="element-194" data-mp="2mryaxc5k1zfc">
              ✅ {audience}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}